import { Skill } from '../types';
import { skills } from '../data/portfolioData';

// import datoCMSClient from './datoCMSClient';

export async function getSkills(): Promise<Skill[]> {
  return skills;
}
